export default {
    error: {
        ops: 'Ops! Algo deu errado.',
        tryAgain: 'Tentar novamente',
        pleaseTryAgain: 'Por favor, tente novamente <br />clicando no botão abaixo.'
    },

    rating: {
        send: 'Enviar',
        hi: 'Oi {strName} :)',
        areYouLiking: 'Está curtindo o Astrolink?'
    },

    typeForm: {
        url: 'https://astrolink.typeform.com/to/YaXB4H?email={mailAddress}'
    },

    playStore: {
        reviewButton: 'Avaliar na Playstore',
        goodYouAreLiking: 'Que bom que você está gostando!',
        url: 'https://play.google.com/store/apps/details?id=com.astrolink.webapp',
        reviewOnStore: 'Poderia nos avaliar na loja? <br /> Sua opinião é muito importante para nós!'
    },

    appleStore: {
        reviewButton: 'Avaliar na App Store ',
        url: 'https://apps.apple.com/br/app/astrolink-astrology-chart/id1598327566'
    }
};